export const TRUSTED_NOTIFIER_MANAGER_CONTRACT_ADDRESS = '0x6f08105c8CEef2BC5653640fcdbBE1e7bb519D39';
//# sourceMappingURL=constants.js.map